import { useEffect } from 'react';
import { connect } from 'react-redux';
import { Route, Navigate, useSearchParams } from 'react-router-dom';
import { useNavigate, Routes } from 'react-router';
import Cookies from 'js-cookie';
import { jwtDecode } from 'jwt-decode';
import { userAuthentication } from '../redux/UserInfo/isLoggedActions';
import DbConnectionLayout from '../Components/DbConnection/layout';
import DatasetLayout from './_dataset/layout';
import AddUser from '../pages/AddUser';
import AdminUser from '../pages/AdminUser';
import UserProf from '../pages/UserProf';
import Groups from '../pages/Groups';
import GroupDetails from '../pages/GroupDetails';
import Admins from '../pages/Admins';
import Workspace from '../pages/Workspace';
import SubWork from '../pages/SubWork';
import SubWorkDetails from '../pages/SubWorkDetails';
import AccessPage from '../pages/AccessPage';
import AccessPageforContents from '../pages/AccessPageforContents';
import AccessRestricted from '../pages/AccessRestricted';
import { localEndPoint } from './ServerCall/EnvironmentVariables';
import NewDataset from '../pages/NewDataset';
import DataViewer from './DataViewer/DataViewer';
import EditFlatFileData from './DataConnection/EditFlatFileData';
import FlatFileUpload from './DataConnection/FlatFileUpload';
import BackButtonHandler from './BackButtonHandler';
import { DeleteAllCookies } from '../Components/CommonFunctions/CommonFunctions';
import Logger from '../Logger';
import FetchData from './ServerCall/FetchData';
import Layout from './Layout';
import { useDispatch } from 'react-redux';
import EditDbConnection from '../pages/EditDbConnection';
import NewDBConnection from '../pages/NewDBConnection';
import SettingsPage from './SettingsPage';
import TVDisplay from './DashBoard/TVDisplay';
import EditDataset from '../pages/EditDataset';
import WebApiDataSource from './DataConnection/WebApiDataSource/WebApiDataSource';

const Home = (props: any) => {
  let navigate = useNavigate();
  const dispatch = useDispatch();
  const [searchParams] = useSearchParams();
  const workspaceId = searchParams.get('workspaceId');
  const playbookId = searchParams.get('playbookId');
  const localStoragePlaybookId = localStorage.getItem('playbookId');
  const localStorageWorkspaceId = localStorage.getItem('workspaceId');

  useEffect(() => {
    const authenticateUser = async () => {
      let decodedToken: any = {};
      try {
        let authToken = Cookies.get('authToken');

        const refreshToken = Cookies.get('refreshToken');

        const defaultToken = import.meta.env.VITE_AUTH_TOKEN;
        const defaultRefreshToken = import.meta.env.VITE_REFRESH_TOKEN;

        if (!authToken) {
          Logger('info', 'No Token Found:', authToken);
          localStorage.setItem('accessToken', defaultToken);
          authToken = defaultToken;
        }
        if (!refreshToken) {
          Logger('info', 'No RefreshToken Found:', refreshToken);
          Cookies.set('refreshToken', defaultRefreshToken);
        }
        // Create an Axios instance with the auth token
        // const axiosInstance = axios.create({
        //   headers: {
        //     Authorization: `Bearer ${authToken}`,
        //     // "X-TENANT-ID": "silzila",
        //     "Content-type": "application/json",
        //   },
        // });

        // Verify the token with the server
        // const response = await axiosInstance.get(`${serverEndPoint}checktoken`);
        const response = await FetchData({
          requestType: 'noData',
          url: 'checktoken',
          method: 'GET',
          headers: {
            Authorization: `Bearer ${authToken}`,
            'Content-type': 'application/json',
          },
        });
        Logger('info', 'response', response);

        if (response && response.status) {
          localStorage.setItem('accessToken', authToken);
          localStorage.setItem('isLoggingOut', 'false');

          Logger('info', 'Valid accessToken:', authToken);

          // Decode the token to extract user role
          decodedToken = jwtDecode(authToken);

          const userRole = decodedToken.access;
          sessionStorage.setItem('access', userRole);
          const payload = {
            isUserLogged: true,
            accessToken: authToken,
            tokenType: '',
            access: userRole, // Store the role in Redux
            /**
             * below data will be set by Header.tsx
             */
            email: '',
            firstName: '',
            lastName: '',
            avtar: '',
          };
          dispatch(userAuthentication(payload));
          if (localStoragePlaybookId && localStorageWorkspaceId) {
            navigate(
              `/playbook?workspaceId=${localStorageWorkspaceId}&playbookId=${localStoragePlaybookId}`,
            );
          }
          localStorage.removeItem('playbookId');
          localStorage.removeItem('workspaceId');
        } else {
          Logger('error', 'Invalid Token:', authToken);
          // Redirect to signin if token is invalid
          // window.location.href = `${localEndPoint}auth/business/signin`;
        }
      } catch (err) {
        if (!window.location.href.includes('dashboard')) {
          console.error('Authentication Error:', err);

          setTimeout(() => {
            const payload = {
              isUserLogged: false,
              accessToken: '',
              tokenType: '',
              access: decodedToken.access, // Store the role in Redux
            };

            dispatch(userAuthentication(payload));

            if (window.location.protocol === 'https:') {
              if (decodedToken.access === 'community') {
                window.location.href = `${localEndPoint}auth/community/signin`;
              } else {
                window.location.href = `${localEndPoint}auth/business/signin`;
              }
            }
          }, 2000);

          DeleteAllCookies();
          localStorage.clear();
          Cookies.remove('authToken');
        }
      }
    };

    if (!window.location.href.includes('dashboard')) {
      authenticateUser();
    }
  }, [props]);

  useEffect(() => {
    const handleBeforeUnLoad = (event: any) => {
      // Checking condition for preventing close warning in case of logout
      if (localStorage.getItem('isLoggingOut') !== 'true') {
        // Display a confirmation dialog (modern browsers may suppress this)
        event.preventDefault();

        // Setting a returnValue is required for older browsers

        //event.returnValue = "Are you sure you want to leave?";

        return (event.returnValue = '');
        // The event does not always show a confirmation dialog in modern browsers,
        // but this can help detect when the event occurs.
      }
    };

    window.addEventListener('beforeunload', handleBeforeUnLoad);

    return () => window.removeEventListener('beforeunload', handleBeforeUnLoad);
  }, []);

  // Destructure props for easier access
  const { isUserLogged, access } = props;

  // Define role-based route access
  const renderRoutes = () => {
    if (!isUserLogged) {
      if (!window.location.href.includes('dashboard')) {
        if (playbookId && workspaceId) {
          localStorage.setItem('playbookId', playbookId);
          localStorage.setItem('workspaceId', workspaceId);
        }
        return <Route path="*" element={<Navigate to="/login" replace />} />; // Redirect to login if not logged in
      }
    }

    // Common routes accessible by all roles
    const commonRoutes = [
      {
        path: '/',
        element: (
          <Layout>
            <Workspace />
          </Layout>
        ),
      },
      { path: '/update-profile', element: <UserProf /> },
      {
        path: '/settings/*',
        element: <SettingsPage />,
      },
      {
        path: '/workspace/:parentId',
        element: (
          <Layout>
            <SubWork />
          </Layout>
        ),
      },
      { path: '/workspace/access/:parentId', element: <AccessPage /> },
      { path: '/display/:parentId', element: <TVDisplay /> },
      { path: '/content/access/:parentId', element: <AccessPageforContents /> },
      {
        path: '/SubWorkspaceDetails/:parentId',
        element: (
          <Layout>
            <SubWorkDetails />
          </Layout>
        ),
      },
      {
        path: '/newdataconnection/:parentId',
        element: (
          <DbConnectionLayout>
            <NewDBConnection />
          </DbConnectionLayout>
        ),
      },
      {
        /** there will be query param  workspaceid */
        path: '/dbconnection/:connectionId',
        element: (
          <DbConnectionLayout>
            <EditDbConnection />
          </DbConnectionLayout>
        ),
      },
      {
        path: '/newdataset/:parentId',
        element: (
          <DatasetLayout>
            <NewDataset />
          </DatasetLayout>
        ),
      },
      {
        path: '/editdataset/:datasetId',
        element: (
          <DatasetLayout>
            {/* <EditDataSet /> */}
            <EditDataset />
          </DatasetLayout>
        ),
      },
      {
        path: '/playbook',
        element: <DataViewer />,
      },
      { path: '/flatfileupload/:parentId', element: <FlatFileUpload /> },
      { path: '/editflatfile/:parentId', element: <EditFlatFileData /> },
      { path: '/webapidatasource/:parentId/:connectionId?', element: <WebApiDataSource /> },
      { path: '/login', element: <AccessRestricted /> },
    ];

    const sharedLinkRoutes = [
      {
        path: '/playbook',
        element: <DataViewer isFromSharedLink={window.location.href.includes('dashboard')} />,
      },
      {
        path: '/dashboard/:link',
        element: <DataViewer isFromSharedLink={true} />,
      },
    ];

    // Routes accessible by 'admin' and 'account_admin'
    const adminRoutes = [
      {
        path: '/admin/users',
        element: (
          <Layout>
            <AdminUser />
          </Layout>
        ),
      },
      {
        path: '/admin/groups',
        element: (
          <Layout>
            <Groups />
          </Layout>
        ),
      },
      // {
      //   path: '/settings/sso-configuration',
      //   element: (
      //     <Layout>
      //       <SSOConfiguration />
      //     </Layout>
      //   ),
      // },
      {
        path: '/group-details/:groupId',
        element: (
          <Layout>
            <GroupDetails />
          </Layout>
        ),
      },
      {
        path: '/users/add',
        element: (
          <Layout>
            <AddUser />
          </Layout>
        ),
      },
      // { path: "/admin/admins", element: <Admins /> },
    ];

    // Routes accessible only by 'account_admin'
    const accountAdminRoutes = [
      // { path: "/users/add", element: <AddUser /> },
      {
        path: '/admin/admins',
        element: (
          <Layout>
            <Admins />
          </Layout>
        ),
      },
    ];

    let routesToRender = [...commonRoutes];

    if (access === 'account_admin') {
      routesToRender = [...routesToRender, ...adminRoutes, ...accountAdminRoutes];
    } else if (access === 'admin') {
      routesToRender = [...routesToRender, ...adminRoutes];
      // 'admin' cannot access '/admin/admins'
    } else if (window.location.href.includes('dashboard')) {
      routesToRender = [...sharedLinkRoutes];
    }
    // 'user' role does not get additional routes beyond commonRoutes

    return routesToRender.map((route, index) => (
      <Route key={index} path={route.path} element={route.element} />
    ));
  };

  return (
    <>
      <BackButtonHandler />
      <Routes>
        {renderRoutes()}
        {/* Optionally, add a catch-all route for 404 */}
        <Route path="/login" element={<AccessRestricted />} />
        <Route path="*" element={<AccessRestricted />} />
      </Routes>
    </>
  );
};

// Map Redux state to component props
const mapStateToProps = (state: any) => {
  return {
    isUserLogged: state.isLogged.isUserLogged,
    access: state.isLogged.access, // Map 'access' from Redux state
  };
};

export default connect(mapStateToProps, null)(Home);
